import { render } from "./cajachica.vue?vue&type=template&id=fa3be392"
import script from "./cajachica.vue?vue&type=script&lang=js"
export * from "./cajachica.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__